import type { PropsWithChildren } from "react";
import { useEffect } from "react";

import { useSessionStore } from "@/entities/session";
import { api } from "@/shared/api";

export const AuthLayout = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    const refreshTokens = () => {
      const refreshToken = useSessionStore.getState().refreshToken;

      if (refreshToken) {
        api
          .post("/authorization/refresh", { refreshToken })
          .then((response) => {
            if (response.data) {
              useSessionStore
                .getState()
                .setAccessToken(response.data.accessToken);
              useSessionStore
                .getState()
                .setRefreshToken(response.data.refreshToken);
            }
          })
          .catch(() => {
            useSessionStore.getState().logout();
          });
      }
    };
    const intervalId = setInterval(refreshTokens, 3600000);

    return () => clearInterval(intervalId);
  }, []);

  return children;
};
